<script lang="ts">
	import { page } from '$app/stores';
	import { onMount, setContext } from 'svelte';
	import { createUserStore } from '$lib/stores/user';
	import { createNavigationStore } from '$lib/stores/navigationStore';
	import { invalidate } from '$app/navigation';
	import ErrorDialog from '$lib/components/UI/ErrorDialog.svelte';
	import { createErrorStore } from '$lib/stores/errorStore.js';
	import { loadCompleteUser } from '$lib/database/manager.js';
	import '../main.css';
	import '../app.css';
	import ProfileComponent from '$lib/components/UI/ProfileComponent.svelte';
	import { t } from '@riva-mono/common';
	import { createContentStore } from '$lib/stores/contentStore';
	let { data, children } = $props();

	let { supabase, session } = data;
	const navigationStore = createNavigationStore({
		back: '/',
		previousPages: []
	});

	let dialog: HTMLDialogElement | undefined = $state();

	let userStore = createUserStore({ loading: true });
	let content = createContentStore();
	setContext('user', userStore);
	setContext('nav', navigationStore);
	setContext('content', content);

	const errorStore = createErrorStore(null);
	setContext('error', errorStore);

	function preventDefault(event: Event) {
		event.preventDefault();
	}

	async function loadUserData() {
		if (data.session) {
			$userStore.loading = true;
			await loadCompleteUser(supabase, data.session, userStore);
			$userStore.loading = false;
		}
	}

	onMount(() => {
		if (!data.session) {
			$userStore.loading = false;
		}
		if (supabase) {
			loadUserData();
			const {
				data: { subscription }
			} = supabase.auth.onAuthStateChange((event, _session) => {
				if (_session?.expires_at !== session?.expires_at) {
					invalidate('supabase:auth');
				}
			});
			return () => subscription.unsubscribe();
		}
	});
</script>

<svelte:head>
	<meta name="description" content={$t('common.head.description')} />
	<meta name="keywords" content="healthcare, medical, startup, health, manifesto" />
	<meta name="author" content="Riva" />
	<meta property="og:title" content="Riva | {$t('common.head.baseline')}" />
	<meta property="og:description" content={$t('common.head.description')} />
	<meta property="og:image" content={$page.url.origin + '/og-image.png'} />
	<title>{$t('common.head.baseline')}</title>
</svelte:head>

<ErrorDialog />

{@render children?.()}

<!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->
<dialog
	id="profileDialog"
	role="button"
	bind:this={dialog}
	onmousedown={(e) => {
		if (e.target === dialog) {
			dialog.close();
			document.body.removeEventListener('touchmove', preventDefault);
			document.body.style.overflow = 'auto';
		}
	}}
>
	{#if data.supabase}
		<ProfileComponent
			supabase={data.supabase}
			session={data.session}
			closeCallback={() => {
				dialog?.close();
			}}
		/>
	{/if}
</dialog>

<style>
	dialog {
		border-radius: 0.2em;
		border: none;
		padding: 0;
		border-radius: 1rem;
		max-width: 650px;
		width: 90%;
		box-shadow: 0 30px 50px -25px rgba(30, 0, 0, 0.25);
	}
</style>
